<div class="flex-fill">
    <div class="row">
        <div class="col-lg-16 col-md-18 col-xl-18">
            <h5 class="mb-0">
                Ingepland personeel {{ formData.orginal?.worknumber ?? formData.orginal?.afas_project_id }}

                @if (!formData.form.controls.employeePlanning.disabled) {
                    <button
                        (click)="addDefaults()"
                        color="primary"
                        mat-icon-button
                        matTooltip="Voeg standaardpersoneel toe">
                        <i class="fas fa-people-group"></i>
                    </button>
                }
            </h5>

            <table
                class="table table-hover"
                [class.table-last-col]="
                    !formData.form.controls.employeePlanning.disabled &&
                    (formData.form.controls.employeePlanning.length > 0 || hiringStaffPheFields?.length)
                ">
                <tr>
                    <th>Functie</th>
                    <th>Medewerker</th>
                    <th style="width: 115px; min-width: 115px">Van</th>
                    <th style="width: 65px; min-width: 65px">Tot</th>
                    <th>Route</th>
                    <th>Opmerking</th>
                    @if (
                        !formData.form.controls.employeePlanning.disabled &&
                        (formData.form.controls.employeePlanning.length > 0 || hiringStaffPheFields?.length > 0)
                    ) {
                        <th>
                            <button class="delete-button" (click)="deleteAll()" color="warn" mat-icon-button>
                                <mat-icon class="fas fa-trash"></mat-icon>
                            </button>
                        </th>
                    }
                </tr>

                @for (formgroup of formData.form.controls.employeePlanning.controls; track formgroup) {
                    @let leaveUserDates = (formgroup.value.user_id && employeeLeaves[formgroup.value.user_id]) || [];

                    <tr [formGroup]="formgroup">
                        <td>
                            {{ formgroup.controls.function?.value }}
                        </td>
                        <td
                            [class.leave]="leaveUserDates && (leaveUserDates | filter: true : 'blocking').length > 0"
                            [class.deleted]="employeeMap?.get(formgroup.controls.user_id.value)?.deleted_at">
                            {{ formgroup.controls.employee?.value }}
                            @if (leaveUserDates && leaveUserDates.length > 0) {
                                @for (leaveUserDate of leaveUserDates; track leaveUserDate.leave.id) {
                                    <div class="d-flex justify-content-between text-nowrap gap-2 text-muted small mt-1">
                                        <i class="fa-duotone {{ leaveUserDate.leave.hourtype | hourtypeIcon }}"></i>
                                        <span class="flex-ellipsis">{{ leaveUserDate.leave.hourtype | hourtype }}</span>
                                        <span>
                                            @if (leaveUserDate.leave.close_period) {
                                                Hele dag
                                            } @else {
                                                {{ leaveUserDate.date.beginDate | date: 'EEE HH:mm' }} -
                                                {{ leaveUserDate.date.endDate | date: 'HH:mm' }}
                                            }
                                        </span>
                                    </div>
                                }
                            }
                        </td>
                        <td class="datetime-input" matTooltip="{{ formgroup.controls.conflictText?.value }}">
                            <app-datetime-input
                                [formControl]="formgroup.controls?.begindate"
                                labelDate="start"
                                labelTime="tijd" />
                        </td>
                        <td class="datetime-input">
                            <app-datetime-input
                                [formControl]="formgroup.controls?.enddate"
                                [defaultDate]="formData?.form?.value?.mainPlanningHas?.phe?.enddate"
                                [hideDate]="true"
                                labelDate="eind"
                                labelTime="tijd" />
                        </td>
                        <td
                            class="p-1 curpoint text-center"
                            [matTooltip]="formgroup.controls.origin?.value"
                            [matTooltipDisabled]="formgroup.disabled"
                            (click)="selectAddress(formgroup)"
                            matRipple
                            width="120">
                            <app-address-icon
                                class="me-1 ms-1"
                                [address]="formgroup.controls.origin?.value ?? ''"
                                [userId]="formgroup.value.user_id"
                                [location]="formData?.form?.value?.planning?.location"
                                [users]="employees" />
                            -
                            <app-address-icon
                                class="me-1 ms-1"
                                [address]="formgroup.controls.work_begin?.value ?? ''"
                                [location]="formData?.form?.value?.planning?.location"
                                [userId]="formgroup.value.user_id"
                                [users]="employees" />
                            @if (formgroup.controls.work_begin?.value !== formgroup.controls.work_end?.value) {
                                <app-address-icon
                                    class="me-1 ms-1"
                                    [address]="formgroup.controls.work_end?.value ?? ''"
                                    [userId]="formgroup.value.user_id"
                                    [location]="formData?.form?.value?.planning?.location"
                                    [users]="employees" />
                            }
                            -
                            <app-address-icon
                                class="me-1 ms-1"
                                [address]="formgroup.controls.destination?.value ?? ''"
                                [userId]="formgroup.value.user_id"
                                [location]="formData?.form?.value?.planning?.location"
                                [users]="employees" />
                        </td>
                        <td class="text-input">
                            <input
                                class="row-input"
                                [formControl]="formgroup.controls.comment"
                                autocomplete="off"
                                placeholder="Omschrijving" />
                        </td>
                        @if (!formgroup.disabled) {
                            <td class="button">
                                <button class="delete-button" (click)="delete(formgroup)" color="warn" mat-icon-button>
                                    <mat-icon class="fas fa-trash"></mat-icon>
                                </button>
                            </td>
                        }
                    </tr>
                }
                @if (hiringStaffPheFields?.length) {
                    @for (pheField of hiringStaffPheFields; track pheField.form.value) {
                        <tr>
                            @for (column of pheField | orderTableFields: hiringStaffTableHeader; track $index) {
                                @if (column.field) {
                                    <td class="hire-input" [attr.colspan]="column.colSpan > 1 ? column.colSpan : null">
                                        <app-field-input
                                            [tableStyle]="true"
                                            [field]="column.field"
                                            [formData]="formData" />
                                    </td>
                                } @else {
                                    <td class="hire-input" [attr.colspan]="column.colSpan"></td>
                                }
                            }

                            @if (!pheField.form.disabled) {
                                <td class="hire-input">
                                    <button
                                        class="delete-button"
                                        (click)="removeHiringPhe(pheField)"
                                        color="warn"
                                        mat-icon-button>
                                        <mat-icon class="fas fa-trash"></mat-icon>
                                    </button>
                                </td>
                            }
                        </tr>
                    }
                }
            </table>
        </div>

        <div class="col-lg-8 col-md-6 col-xl-6">
            <h5>Aantal per functie</h5>

            <table class="table">
                <tr>
                    <th>Functie</th>
                    <th>Aantal</th>
                </tr>
                @for (sum of sums; track sum.function) {
                    <tr>
                        <td class="function-cell">
                            {{ sum.function }}

                            @if (!formData.form.controls.employeePlanning.disabled) {
                                <i
                                    class="fa fa-plus ps-2"
                                    (click)="filterFunction = sum.function; addEmployeeSelect.open()"></i>
                            }
                        </td>
                        <td>
                            {{ sum.amount }}

                            @if (sum.function === 'Verkeersregelaar') {
                                / {{ this.formData.form.controls.planning?.get('traffic_controllers')?.value }}
                            }
                        </td>
                    </tr>
                }
            </table>

            @if (!formData.form.controls.employeePlanning.disabled) {
                <ng-select
                    class="ng-select-fill employee-select ng-select-subtext"
                    data-testid="planning-employee-add-select"
                    #addEmployeeSelect
                    [formControl]="fcEmployee"
                    [clearable]="true"
                    [items]="filteredEmployees | filter: filterFunction : 'function'"
                    [addTag]="addHiringTagFn"
                    [searchFn]="searchFn"
                    (change)="onEmployeeChange($event)"
                    (blur)="filterFunction = null"
                    name="employee-filter"
                    placeholder="Medewerker toevoegen"
                    notFoundText="Geen medewerkers gevonden"
                    bindLabel="name"
                    bindValue="id"
                    tabIndex="-1">
                    <ng-template ng-tag-tmp let-search="searchTerm"> "{{ search }}" toevoegen als inhuur </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                        <div class="d-flex justify-content-between w-100 gap-2">
                            <span>{{ item.name }}</span>
                            <small class="flex-ellipsis">{{ item.companyName ?? item.function }}</small>
                        </div>

                        @if (item.leaves?.length) {
                            @for (leave of item.leaves; track leave.id) {
                                <div
                                    class="d-flex align-items-center justify-content-between w-100 text-muted small gap-2 mt-1">
                                    <i class="fa-duotone {{ leave.leave.hourtype | hourtypeIcon }}"></i>
                                    <span>{{ leave.leave.hourtype | hourtype }}</span>
                                    <span>
                                        @if (leave.leave.close_period) {
                                            Hele dag
                                        } @else {
                                            {{ leave.date.beginDate | date: 'EEE HH:mm' }} -
                                            {{ leave.date.endDate | date: 'HH:mm' }}
                                        }
                                    </span>
                                </div>
                            }
                        }
                    </ng-template>
                </ng-select>
            }
        </div>
    </div>
</div>
